module.exports = __webpack_public_path__ + "static/img/qiweihu_title.ee56c62e.png";